<template>
  <div id="app" :data-page="$route.matched[0].props.default.pageclass" v-if="item !== false" :key="this.id" :class="'rtl ' + (show_side_menu ? 'menu_open' : '') + ' ' + (show_share ? 'share_pop_open' : '')" :style="{'--def-color': '#' + item.color }">


    <div class="dark-overlayer">
      <div class="pic_bg" :style="'background-image:url(' + item.pic_cover_tumb + ')'"></div>
      <svg id="pic_bg-ie" width="100vw" height="100vh" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="svgBlur" style="position: absolute; left: 0px; top: 0px;">
        <filter id="svgBlurFilter"><feGaussianBlur in="SourceGraphic" stdDeviation="33"></feGaussianBlur></filter>
        <image :xlink:href="item.pic_cover_tumb" x="0" y="0" height="100%" width="100%" preserveAspectRatio="slice" filter="url(#svgBlurFilter)"></image>
      </svg>
    </div>

    <mblheader :widgets="widgets" :item="item" :user="user" ref="sidebar" @open_share="show_share=true" @open_side_bar="show_side_menu=!show_side_menu" v-if="is_mobile()"></mblheader>
    <mblsidebar :widgets="widgets" :item="item" :user="user" :key="user.id" ref="sidebar" v-if="is_mobile()" @close_login_pop="show_side_menu=false" @open_login_pop="show_login=true"></mblsidebar>

    <sidebar :item="item"  :user="user" ref="sidebar" @open_share="show_share=true" @open_login_pop="show_login=true"></sidebar>
    
    <div id="main_area">

      <MSHeader :widgets="widgets" :item="item" :user="user" @open_login_pop="show_login=true"></MSHeader>
      <div id="content">

      <transition name="fade" mode="out-in">
        <router-view :widgets="widgets" :item="item" :key="$route.path" @loading_complete="/*show_splash_screen=false;*/ is_show_loader=false;" @show_loader="is_show_loader=true;" @play_song="play_song"></router-view>
      </transition>
        
      </div>


      <div class="template-3-footer">
        <ul>
          <li v-for="logo in item.companies_logos" :key="logo.id">
            <a :href="logo.url" target="_blank" v-if="logo.url"><img :src="logo.pic_path" alt="" :title="יוטיוב" class="img-responsive"></a>
            <a target="_blank" v-if="!logo.url"><img :src="logo.pic_path" alt="" :title="יוטיוב" class="img-responsive"></a>
          </li>
          <li><a href="https://mediaforest-group.com/" target="_blank"><img src="https://www.mysong.co.il/themes/NBK/images/mediaforest_logo.png" alt="" class="img-responsive"></a></li>
        </ul>
      </div>




    </div>

    <login v-show="show_login" @close="show_login=false" />
    <share v-show="show_share" :item="item" @close="show_share=false" />

  </div>

 
</template>

<script>

import MSHeader from './components/header.vue'
import sidebar from './components/sidebar.vue'
import login from './components/login.vue'
import share from './components/share.vue'
import mblheader from './components/mblheader.vue'
import mblsidebar from './components/mblsidebar.vue'

window.api_url = 'https://www.mysong.co.il/api_vue/'; 

export default {
  name: 'app',
  components: {
    MSHeader, sidebar, login, share, mblheader, mblsidebar
  },
  data(){
    return {
      id: (window.item_id > 0 ? window.item_id : this.$route.params.id),
      item: false,
      widgets: {},
      user: false,
      show_login: false,
      show_share: false,
      show_side_menu: false,
    }
    
  },
  mounted() {

    var self = this;

    var interval_var = null;

    interval_var = setInterval(() => {
      self.id = (window.item_id > 0 ? window.item_id : this.$route.params.id);
      if(self.id > 0)
      {
        
        clearInterval(interval_var)
        // categories
        self.$http.post(window.api_url + 'general', {id: self.id}).then(function(data){

          self.widgets = data.data.data.widgets;
          self.item = data.data.data.item;
          self.user = data.data.data.user;

          if (self.item.first_tab != '')
          { //alert(self.widgets[0].link)
            //this.$router.push({name: self.widgets[0].link});

            for (let i in self.widgets)
            {
              if (self.widgets[i].tab == self.item.first_tab)
              {
                self.$router.push(self.widgets[i].link);
                break;
              }
            }
            
            
          }

        });
      }
    }, 150);

  },

  methods:{
    play_song(id){
      //alert(this.isMobile())
      this.$refs.sidebar.play_by_id(id)
    },
  }
}
</script>

<style lang="scss">
body{
   #sidebar #type_tag { border-top-color: var(--def-color);}
   header ul li:hover a, header ul li a.router-link-active { color: var(--def-color); }
   #sidebar .header a { color: var(--def-color);}
   header ul li a.router-link-active:before, header ul > li:hover > a:before { background: var(--def-color);}
   #player_buttons .play_btn { color: var(--def-color);}
   input[type=range]::-webkit-slider-thumb { background: var(--def-color) !important; } 
   #sidebar ul li:hover, #sidebar ul li.active { border-right-color: var(--def-color); }
   .menu_open #side_menu a.router-link-active { color: var(--def-color);  }
   header .soci a { color: var(--def-color);} 
}
</style>